import {
    DEALERWALLETEXCELPDFFILE_FAILED,
    DEALERWALLETEXCELPDFFILE_SUCCESS,
    RESET_DEALERWALLETEXCELPDFFILE,
    LOADING_DEALERWALLETEXCELPDFFILE,
    NETWORK_ERROR_DEALERWALLETEXCELPDFFILE

} from '../types/index';
import { dealerServices } from "../../config/axios";

const resetDealerWalletExcelPdfFile = () => {
    return { type: RESET_DEALERWALLETEXCELPDFFILE };
};
const dealerWalletExcelPdfFileList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERWALLETEXCELPDFFILE });
    await dealerServices
        .post("walletExcelPdfFile", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerWalletExcelPdfsuccess(res.data));
                    break;
                default:
                    dispatch(dealerWalletExcelPdfFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERWALLETEXCELPDFFILE,
                payload: err
            });
        });
};

function dealerWalletExcelPdfsuccess(data) {
    return {
        type: DEALERWALLETEXCELPDFFILE_SUCCESS,
        payload: data
    };
}
function dealerWalletExcelPdfFailed(data) {
    return {
        type: DEALERWALLETEXCELPDFFILE_FAILED,
        payload: data
    };
}

export { resetDealerWalletExcelPdfFile, dealerWalletExcelPdfFileList }